const getBaseURL = (): string => {
  if (import.meta.env.VITE_API_URL) {
    return import.meta.env.VITE_API_URL;
  }
  return "/api";
};

export type PricingInterval = "monthly" | "annual" | "lifetime";

export interface PodcastPricing {
  id: string;
  podcastId: string;
  interval: PricingInterval;
  priceCents: number;
  trialDays: number;
  stripePriceId: string | null;
  isActive: boolean;
  createdAt: string;
}

export interface CreatePricingInput {
  interval: PricingInterval;
  priceCents: number;
  trialDays?: number;
}

async function request<T>(url: string, options: RequestInit = {}): Promise<T> {
  const res = await fetch(url, {
    ...options,
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw new Error(body.error || `Request failed with status ${res.status}`);
  }

  if (res.status === 204) {
    return undefined as T;
  }

  return res.json();
}

export async function listPricing(orgId: string, podcastId: string): Promise<PodcastPricing[]> {
  const { pricing } = await request<{ pricing: PodcastPricing[] }>(
    `${getBaseURL()}/organizations/${orgId}/podcasts/${podcastId}/pricing`,
  );
  return pricing;
}

export async function createPricing(
  orgId: string,
  podcastId: string,
  input: CreatePricingInput,
): Promise<PodcastPricing> {
  const { pricing } = await request<{ pricing: PodcastPricing }>(
    `${getBaseURL()}/organizations/${orgId}/podcasts/${podcastId}/pricing`,
    {
      method: "POST",
      body: JSON.stringify(input),
    },
  );
  return pricing;
}

export async function deletePricing(
  orgId: string,
  podcastId: string,
  pricingId: string,
): Promise<void> {
  await request<void>(
    `${getBaseURL()}/organizations/${orgId}/podcasts/${podcastId}/pricing/${pricingId}`,
    { method: "DELETE" },
  );
}
